import { Injectable } from "@angular/core";
import { TokenStorage } from "./helper";
import { ConfigService } from "../../services/config.service";
import { AuthHelper } from "./auth-helper";
import { ClaimTypes } from "../../helpers/claimtype";

@Injectable({
  providedIn: "root"
})
export class TokenService {
  private _jwtHelper = new AuthHelper();

  constructor(private _configService: ConfigService) {}

  setToken(token: string, refreshToken?: string) {
    const authConfig = this._configService.getAuthConfig();

    switch (authConfig.TokenStorage) {
      case TokenStorage.LOCAL_STORAGE:
        localStorage.setItem(authConfig.TokenName, token);

        if (refreshToken) {
          localStorage.setItem(authConfig.RefreshTokenName, refreshToken);
        }

        break;

      case TokenStorage.SESSION_STORAGE:
        sessionStorage.setItem(authConfig.TokenName, token);

        if (refreshToken) {
          sessionStorage.setItem(authConfig.RefreshTokenName, refreshToken);
        }

        break;

      default:
        throw new Error("Token storage not found");
    }
  }

  setRefreshToken(refreshToken: string) {
    const authConfig = this._configService.getAuthConfig();

    switch (authConfig.TokenStorage) {
      case TokenStorage.LOCAL_STORAGE:
        localStorage.setItem(authConfig.RefreshTokenName, refreshToken);

        break;

      case TokenStorage.SESSION_STORAGE:
        sessionStorage.setItem(authConfig.RefreshTokenName, refreshToken);

        break;

      default:
        throw new Error("Token storage not found");
    }
  }

  getToken(): string {
    const authConfig = this._configService.getAuthConfig();

    switch (authConfig.TokenStorage) {
      case TokenStorage.LOCAL_STORAGE:
        return localStorage.getItem(authConfig.TokenName);

      case TokenStorage.SESSION_STORAGE:
        return sessionStorage.getItem(authConfig.TokenName);

      default:
        throw new Error("Token storage not found");
    }
  }

  toJSON() {
    return JSON.parse(this._jwtHelper.decodeToken(this.getToken()));
  }

  getValueFromClaim(claim: string): string {
    return this._jwtHelper.decodeToken(this.getToken())[claim];
  }

  getValueFromProperty(propertyName: string): string {
    return this._jwtHelper.decodeToken(this.getToken())[
      ClaimTypes[propertyName]
    ];
  }

  removeToken() {
    const authConfig = this._configService.getAuthConfig();

    switch (authConfig.TokenStorage) {
      case TokenStorage.LOCAL_STORAGE:
        localStorage.removeItem(authConfig.TokenName);
        localStorage.removeItem(authConfig.RefreshTokenName);
        break;

      case TokenStorage.SESSION_STORAGE:
        sessionStorage.removeItem(authConfig.TokenName);
        sessionStorage.removeItem(authConfig.RefreshTokenName);
        break;

      default:
        throw new Error("Token storage not found");
    }
  }
}
